<template>
  <div class="space-y-8">
    <div class="grid gap-3">
      <button
        v-for="option in goals"
        :key="option.value"
        @click="select(option.value)"
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === option.value ? 'btn-primary shadow-lg' : 'btn-outline hover:bg-base-200',
        ]">
        {{ $t(option.label) }}
      </button>
    </div>

    <button
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50"
      :disabled="!selected"
      @click="$emit('next')">
      {{ $t("smartLeadForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

// Ensure selected is a string
const selected = ref(typeof props.modelValue.goal === "string" ? props.modelValue.goal : "");

const goals = [
  { value: "buildWebsite", label: "smartLeadForm.primaryGoal.options.buildWebsite" },
  { value: "getClients", label: "smartLeadForm.primaryGoal.options.getClients" },
  { value: "fixMaintain", label: "smartLeadForm.primaryGoal.options.fixMaintain" },
];

watch(selected, val => {
  emit("update:modelValue", {
    ...props.modelValue,
    goal: val,
  });
});

function select(value: string) {
  selected.value = value;
}
</script>
